<template>
  <div
    v-show="locales.length > 1"
    class="translatable-locale-tabs flex select-none flex-row"
    :class="{ 'md:px-8 px-2': !this.detail }"
  >
    <div v-if="!this.detail" class="@md/modal:mt-2 md:px-8 @md/modal:px-8 md:w-1/5 @md/modal:w-1/5 md:block hidden"></div>
    <div :class="{'@md/modal:px-8 md:w-3/5 @md/modal:w-3/5': !this.detail, listClasses: true, 'md:space-x-4 space-x-2 md:mb-0 mb-3': this.detail}" v-if="displayType != 'none'">
      <a
        v-for="locale in locales"
        :key="locale.key"
        :dusk="getDuskKey(locale.key)"
        class="locale-tag cursor-pointer font-bold text-80 text-sm"
        :class="{
          'ml-3': !this.detail,
          '-active': locale.key === activeLocale,
          '-error': hasError(locale.key),
        }"
        @click="() => $emit('tabClick', locale.key)"
        @dblclick="() => $emit('doubleClick', locale.key)"
      >
        {{ locale.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'attribute',
    'locales',
    'activeLocale',
    'displayType',
    'detail',
    'errors',
    'errorAttributes',
    'localesWithErrors',
  ],
  computed: {
    listClasses() {
      if (this.displayType === 'column') return ['flex', 'flex-col'];
      return [];
    },
  },

  methods: {
    hasError(locale) {
      if (Array.isArray(this.localesWithErrors) && this.localesWithErrors.includes(locale)) return true;
      if (!this.errors || !this.errorAttributes) return false;

      const errorAttribute = this.errorAttributes[locale];
      return this.errors.has(errorAttribute);
    },

    getDuskKey(locale) {
      if (this.attribute) {
        return `${this.attribute}.${locale}.locale.tab`;
      }

      if (this.errorAttributes && this.errorAttributes[locale]) {
        return `${this.errorAttributes[locale]}.locale.tab`;
      }

      return locale + '.locale.tab';
    },
  },
};
</script>

<style lang="scss">
.translatable-locale-tabs {
  position: relative;
  z-index: 2;
  padding-top: 0.25rem;

  .locale-tag {
    border-bottom: 2px solid transparent;

    &.-active {
      color: rgba(var(--colors-primary-500));
      border-color: rgba(var(--colors-primary-500));
    }

    &.-error {
      color: rgba(var(--colors-red-500));
      border-color: rgba(var(--colors-red-500));

      &.-active {
        color: rgba(var(--colors-primary-500));
      }
    }
  }
}
</style>
